/**
 * The night band in which an agent sends no follow-ups, on the country's
 * clock. Twin of `functions/aiConversation/quietHours.js` in the cloud
 * functions repo (`lead1-crm-cloud-functions`), kept in step by hand like the
 * other mirrors in this folder: DEFAULT_QUIET_HOURS is what the engine runs
 * an agent on when `followUp.quietHours` is missing or malformed, even in
 * one of its two ends, and QUIET_HOUR_PATTERN is the HH:mm it accepts.
 *
 * The band is [start, end): with an 08:30 end, 08:29 is in and 08:30 is out.
 * Equal ends mean no band at all. A follow-up that falls due inside it is
 * cancelled, not held until the morning, except the ones with a threshold up
 * to ACTIVE_GRACE_MS (see aiConversationWindow.js), which go out at any hour.
 * The clock is the country's (`country.timezone`): the same agent in two
 * countries would read the same band on two different clocks.
 */
export const DEFAULT_QUIET_HOURS = { start: '22:00', end: '08:30' };

export const QUIET_HOUR_PATTERN = /^([01]?\d|2[0-3]):([0-5]\d)$/;

export const isQuietHour = (value) =>
  typeof value === 'string' && QUIET_HOUR_PATTERN.test(value);
